/**
 * URL yapısı için temel fonksiyonlar
 */

// Türkçe karakterleri dönüştür ve URL dostu yap
const cleanString = (str: string): string => {
  if (!str) return '';
  
  // Önce büyük İ'yi i'ye çevir
  const normalized = str
    .replace(/İ/g, 'i')
    .toLowerCase()
    .trim();
  
  // Diğer Türkçe karakterleri dönüştür
  return normalized
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9\-]/g, '-') // Sadece küçük harf, rakam ve tire
    .replace(/-+/g, '-') // Ardışık tireleri tekleştir
    .replace(/^-|-$/g, ''); // Baş ve sondaki tireleri kaldır
};

// Başlık için Türkçe karakter düzeltme
export function formatTitle(str: string): string {
  if (!str) return '';
  
  // Baş harfleri büyüt ve Türkçe karakterleri koru
  return str
    .split(' ')
    .map(word => {
      if (word.length === 0) return '';
      // İlk harfi büyüt, Türkçe karakterleri düzgün şekilde dönüştür
      const firstChar = word[0].toLocaleUpperCase('tr-TR');
      const rest = word.slice(1).toLocaleLowerCase('tr-TR');
      return firstChar + rest;
    })
    .join(' ');
}

// URL slug oluştur
export function createSlug(text: string, type?: string): string {
  if (!text) return '';
  
  const slug = cleanString(text);
  
  // URL sonuna -taksi ekle
  if (type === 'taksi') {
    return `${slug}-taksi`;
  }

  return slug;
}

// Tam URL'ler oluştur
export function createCityUrl(name: string): string {
  return `/il/${createSlug(name)}`;
}

export function createDistrictUrl(cityName: string, districtName: string): string {
  return `/ilce/${createSlug(cityName)}/${createSlug(districtName)}`;
}

export function createNeighborhoodUrl(cityName: string, districtName: string, neighborhoodName: string): string {
  return `/mahalle/${createSlug(cityName)}/${createSlug(districtName)}/${createSlug(neighborhoodName)}`;
}

// URL'den slug çıkar
export function extractSlug(url: string): string | null {
  const segments = url.split('/').filter(Boolean);
  return segments[segments.length - 1] || null;
}